module.exports = __webpack_public_path__ + "static/media/banner_04.21c50e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lunbotu/banner_04.jpg
// module id = 1182
// module chunks = 0